import "materialize-css";

const ModalDirective = function () {
    return {
        restrict: 'E',
        link: function (scope, elm, attr) {
            var css = "modal";

            if (attr.height != "floating") {
                css += " modal-fixed-footer";
            }

            if (attr.size) {
                css += " modal-" + attr.size;
            }

            elm.addClass(css);
        }
    }
};

export { ModalDirective };